import axios from 'axios';
import Vue from 'vue'

const state = {
    users: []
}

const getters = {
    users: state => {
        return state.users;
    }
}

const actions = {
    /**
     * Returns promise resolve/reject checked within the Vues 
     * which then populate a custom globalAlert
     */
    async getUsers({ commit }) {
        await axios.get('/api/user')
            .then((response) => {
                commit('setUsers', response.data)
                return Promise.resolve();
            })
            .catch((error) => {
                commit('setUsers', [])
                return Promise.reject(error);
            })
    },
    async addUser({ commit }, user) {
        const response = await axios.post('/api/user', user)
        const newUser = response.data
        commit('addUser', newUser)
    },
    async editUser({ commit }, user) {
        const response = await axios.put('/api/user', user)
        const editUser = response.data
        commit('editUser', editUser)
    },
    async deleteUser({ commit }, user) {
        await axios.put('/api/user/delete', user)
        commit('deleteUser', user)
    }
}

const mutations = {
    setUsers: (state, users) => (state.users = users),
    addUser: (state, user) => (state.users.push(user)),
    deleteUser: (state, user) => (state.users = state.users.filter(thisUser => thisUser.email !== user.email)),
    editUser: function (state, user) {
        var index = state.users.findIndex((obj => obj.id == user.id))
        Vue.set(state.users, index, user) 
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}